import React, {ReactElement, ReactNodeArray, useContext} from 'react';
import Slider from 'react-slick';

import DeviceContext, {Device} from '../../../RootProvider/DeviceContext';

import './Carousel.scss';

interface Props {
  children: ReactNodeArray;
  className?: string;
}

// react slick docs here: https://react-slick.neostack.com/docs/api/

function Carousel({children, className}: Props): ReactElement {
  const currentDevice = useContext(DeviceContext);
  const isMobile = currentDevice === Device.MOBILE;

  return (
    <div data-testid="ui.carousel" className={className}>
      <Slider
        arrows={false}
        dots={isMobile}
        infinite={false}
        initialSlide={isMobile && children.length > 1 ? 1 : undefined}
        slidesToScroll={1}
        slidesToShow={isMobile ? 1 : children.length}
        speed={750}
      >
        {children}
      </Slider>
    </div>
  );
}

export default Carousel;
